import { Component, OnInit } from '@angular/core';
import { UserRole } from './user-roles';
import { UserRoleService } from './user-roles.service';
 
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-user-roles',
  templateUrl: './user-roles.component.html',
  styleUrls: ['./user-roles.component.css']
})
export class UserRolesComponent implements OnInit {

  
  currentPage = 1;
  itemsPerPage = 5;
  pageSize: number;
  userRole = new UserRole();
  userRoles: UserRole[];
  submitted = false;
	message: string;	
	  totalrecord:number;
  userroleFilter: any = { userrolename: '' };
  
  constructor(
    private userRoleService: UserRoleService,
    private route: ActivatedRoute,
    private location: Location
  ) { }
  
  
   private save(): void {
     this.userRoleService.addUserRole(this.userRole)
         .subscribe();
      //   this.goBack();  //for Redirecting to the list view     
   } 

   ngOnInit(): void {
    this.getUserRoles();
  }

  

  update(): void {
    this.submitted = true;
    this.userRoleService.updateUserRole(this.userRole)
        .subscribe(() => this.message = "Customer Updated Successfully!");
  }
 
  delete(): void {
    this.submitted = true;
    this.userRoleService.deleteUserRole(this.userRole.userroletypeid)
        .subscribe(()=> this.message = "User Role Deleted Successfully!");
  }
 
  goBack(): void {
    this.location.back();
  }

  getUserRoles() {
    return this.userRoleService.getUserRoles()
               .subscribe(
                userRoles => {
                  console.log(userRoles);
                  this.userRoles = userRoles;
                  this.totalrecord = this.userRoles.length;
                 }
                );
 }

 public onPageChange(pageNum: number): void {
  this.pageSize = this.itemsPerPage*(pageNum - 1);
}

public changePagesize(num: number): void {
this.itemsPerPage = this.pageSize + num;
}
 

}
